<template>
  <section class="profile__block">
    <div class="profile__block__header">
      <h2>{{ getTranslations.home_profile_default_content_your_performance }}</h2>
    </div>
    <div class="profile__block__content profile__block__content--empty-state">
      <img src="/static/images/empty_home.svg" alt="">
      <h1>{{ getTranslations.home_profile_default_content_no_performance_data_yet }}</h1>
      <p>{{ getTranslations.home_profile_default_content_play_a_game_now }}</p>
        <div class="new_game_buttons_section">
          <div class="btn_left">
            <p>{{ getTranslations.home_home_new_game }}</p>
            <a href="#">
              <img src="static/images/random_icon.svg" alt="" @click.prevent="onClickAction(0)">
            </a>
          </div>
          <div class="btn_right">
            <p>{{ getTranslations.home_modals_games_left_against_friend }}</p>
            <a href="#">
              <img src="/static/images/friend_icon.svg" alt="" @click.prevent="onClickAction(1)">
            </a>
          </div>
        </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'profile-empty-state',
  props: {
    onClickAction: Function,
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/profile/EmptyState.vue